export default __webpack_public_path__ + "static/media/img4.cdc6c403.png";